import React, { FC, useCallback, useEffect, useRef } from "react";
import { ChatMsgDetail } from "../../store/ChatAction";
import { isAgent } from "../../utils";
import { ChatMessageBubble } from "../ChatMessageBubble";
import { OpenUrlCallback } from "../../hooks/useOpenUrlCallback";
import { useChatDispatch } from "../../utils/useChatDispatch";
import { useSelector } from "react-redux";
import { ChatState, VisualState } from "../../store/ChatState";

export interface ChatMarkdownMessageProps {
    readonly message: ChatMsgDetail;
    readonly sibling: boolean;
    readonly time?: string;
    onOpenUrl: OpenUrlCallback;
}

export const ChatMarkdownMessage: FC<ChatMarkdownMessageProps> = props => {
    const { onOpenUrl } = props;
    const agentMessage = isAgent(props.message.user.nick);
    const ref = useRef<HTMLDivElement>();

    const chatDispatch = useChatDispatch();
    const visuals = useSelector<ChatState, VisualState>((state) => state.visuals);
    
    const html = props.message.msg.html;

    const handleLinkClick = useCallback((ev: MouseEvent) => {
        if (onOpenUrl) {
            const link = ev.target as HTMLAnchorElement;
            ev.preventDefault();
            onOpenUrl(link.href, chatDispatch, visuals);
        }
    }, [onOpenUrl]);

    useEffect(() => {
        if (ref.current) {
            ref.current.innerHTML = html;
            if (onOpenUrl) {
                const links = ref.current.querySelectorAll("a");
                links.forEach(link => {
                    link.addEventListener("click", handleLinkClick);
                });

                return () => {
                    links.forEach(link => {
                        link.removeEventListener("click", handleLinkClick);
                    });
                };
            }
        }
        return undefined;
    }, [ref, html, onOpenUrl, handleLinkClick]);

    return (
        <div className="chat-msg">
            <div className="chat-text-container">
                <ChatMessageBubble owner={agentMessage ? "others" : "mine"} hasTail={agentMessage && !props.sibling}>
                    <span className="message-sr-only">{"at " + props.time + (agentMessage ? " the bot said" : " the user said")}</span>
                    <div ref={ref}></div>
                </ChatMessageBubble>
            </div>
        </div>
    );
};

